// @flow

import React from 'react';
import { useTranslation, UseTranslationResponse } from 'react-i18next';
import { getTFunction } from '../../i18n';
import type { FormError, ApiError } from '../../store/reducers/auth';

type Props = {
  error: FormError | ApiError,
  className?: string
}

type Html = {
  __html: string
}

const getErrorString = (error: FormError | ApiError, transResponse: UseTranslationResponse): Html => {
  let __html = '';
  const errorsTFunction = getTFunction('errors');
  if (error.translatedMessage) {
    __html = error.translatedMessage;
  } else if (error.code && transResponse.i18n.exists(`authErrors:${error.code}`)) {
    __html = transResponse.t(error.code);
  } else {
    __html = errorsTFunction('generic');
  }
  return { __html };
};

const AuthError = ({ error, className }: Props) => {
  if (!error) {
    return null;
  }
  const transResponse = useTranslation('authErrors');
  return (
    /* eslint-disable react/no-danger */
    <p
      className={`type-paragraph is-error auth-input__error ${className || ''}`}
      dangerouslySetInnerHTML={getErrorString(error, transResponse)}
    />
  /* eslint-enable react/no-danger */
  );
};

export default AuthError;


// WEBPACK FOOTER //
// ./src/components/shared/AuthError.js